export class Company {
    public id: string;
    public name: string;
    public maxAllowedUsers?: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.maxAllowedUsers = json.maxAllowedUsers;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/company.ts